// extracted by extract-css-chunks-webpack-plugin
module.exports = {"background":"form-control-file-input-styles__background___2cKQG"};
    if(module.hot) {
      // 1679366675997
      var cssReload = require("../../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  